import $ from "jquery"

function input() {

$(document).ready( () => {
    $('.float-container__dropdown').click(toggleDropdown)
    $('.float-container__dropdown').focus(showDropdown)
    $('.float-container__dropdown').blur(hideDropdown)

    $('.float-container__option').not('.float-container__option--create').click(setDropdownValue)

    function showDropdown () {
        const dropdown = $(this)
        setTimeout(() => {
            dropdown.addClass('float-container__dropdown--show')
        }, 100)
    }

    function hideDropdown () {
        const dropdown = $(this)
        setTimeout(() => {
            dropdown.removeClass('float-container__dropdown--show')
        }, 100)
    }

    function toggleDropdown () {
     
        const dropdown = $(this)
        // if (forceShow) {
        //     dropdown.addClass('float-container__dropdown--show')
        // }
        // else {
            dropdown.toggleClass('float-container__dropdown--show')
        // } 
        if (dropdown.find('.float-container__input').val()) {
            dropdown.addClass('active').addClass('fielded')
        } else {
            dropdown.removeClass('active')
        }

        if (dropdown.hasClass('float-container__dropdown--show')) {
            const findActive = dropdown.find('.float-container__option--active')
            if (findActive.length) {
                const list = $('.float-container__options')
                const listTop = list.offset().top
                const activeTop = findActive.offset().top
                list.scrollTop(list.scrollTop() + (activeTop - listTop))
            }
        }
    }

    function setDropdownValue () {
        const dropdown = $(this).closest('.float-container__dropdown')
        const table_dropdown = $(this).closest('.float-container__dropdown-table')
        if (dropdown.length) {
            dropdown.find('.float-container__option--active').removeClass('float-container__option--active')
            $(this).addClass('float-container__option--active')
            dropdown.children('.float-container__dropdown-value').val(this.dataset.value).change()
            dropdown.children('.float-container__input').val(this.innerText)
            dropdown.toggleClass('float-container__dropdown--show')
            toggleDropdown.call(dropdown.get(0))
            return
        }

        if (table_dropdown.length) {
            table_dropdown.find('.float-container__option--active').removeClass('float-container__option--active')
            $(this).addClass('float-container__option--active')
            table_dropdown.children('.float-container__dropdown-value').val(this.dataset.value).change()
            table_dropdown.children('.float-container__table-input').val(this.innerText)

            toggleTableDropdown.call(table_dropdown.get(0))
        }
    }

    $(document).mouseup(function(e) {
        const $options = $('.float-container__dropdown--show')
        if (!$options.is(e.target) && $options.has(e.target).length === 0) {
          $options.removeClass('float-container__dropdown--show');
        }
    })
})

}

export default input
